// extracted by mini-css-extract-plugin
module.exports = {"root":"brand_root__ms4V_","positive":"brand_positive__zHlvK","negative":"brand_negative__dz_qb"};